import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import useFile from '../../../../hooks/api/file/useFile';

export interface Props {
  id: string;
  disabled: boolean;
  value: string | File;
  onChange: (e: File) => void;
  readOnlyMode?: boolean;
}

const UploadInput: FC<Props> = ({ id, disabled, value, onChange, readOnlyMode }: Props) => {
  const { downloadFile } = useFile();
  if (readOnlyMode && typeof value === 'string') {
    return (
      <div>
        {value.length > 0 && (
          <a target="_blank" rel="noreferrer" onClick={() => downloadFile(value)}>
            {value}
          </a>
        )}
        {value.length == 0 && <span>-</span>}
      </div>
    );
  }
  return (
    <div>
      <Form.Control
        id={id}
        disabled={disabled}
        type="file"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.files && e.target.files.length > 0) {
            onChange(e.target.files[0]);
          }
        }}
      />
    </div>
  );
};

export default UploadInput;
